function getAdvisorConfig(appName) {
  const advisorConfig = {
    "Cy": {
      fullRetirementAge: 66,
      ageOfDeath: 95,
      inflationRate: 0.02,
      taxRateBR: 0.212,
      taxRateIR: 0.212,
      taxRateNonQualifiedAssetGains: 0.212,
      includeTheoretical: false,
      managerType: "All",
      riskPeriod: "worst.calendar.year",
      riskAverse: false,
    },
    "Maridea Wealth Management": {
      fullRetirementAge: 66,
      ageOfDeath: 95,
      inflationRate: 0.02,
      taxRateBR: 0.212,
      taxRateIR: 0.212,
      taxRateNonQualifiedAssetGains: 0.212,
      includeTheoretical: false,
      managerType: "All",
      riskPeriod: "worst.calendar.year",
      riskAverse: false,
    },
    "American Portfolios": {
      fullRetirementAge: 66,
      ageOfDeath: 95,
      inflationRate: 0.02,
      taxRateBR: 0.212,
      taxRateIR: 0.212,
      taxRateNonQualifiedAssetGains: 0.212,
      includeTheoretical: false,
      managerType: "ETF Only",
      riskPeriod: "worst.calendar.year",
      riskAverse: false,
    },
  }
  return advisorConfig[appName];
}



export const CyAdvisorConfig = {
  getAdvisorConfig
};



// WEBPACK FOOTER //
// ./src/utilities/advisorConfig.js